export default {
      id: "eta-fill-usage",
      viewBox: "0 0 26 14",
      url: __webpack_public_path__ + "img/icons.svg#eta-fill",
      toString: function () {
        return this.url;
      }
    }